/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_ChampionInputs */



/**
* | output |
* | --- |
* | "Champion" |
*
* @param {League_ChampionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_champion = /** @type {((inputs?: League_ChampionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_ChampionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Champion")
	if (locale === "es") return /** @type {LocalizedString} */ ("Campeón")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Campeão")
	if (locale === "it") return /** @type {LocalizedString} */ ("Campione")
	return /** @type {LocalizedString} */ ("Champion")
});